import { FunctionComponent } from "react";
import { Text } from "@kanda-libs/ks-design-library";

export interface SectionProps {
  title?: string;
  bottomMargin?: boolean;
  className?: string;
  children?: JSX.Element | JSX.Element[];
}

const Section: FunctionComponent<SectionProps> = function ({
  title,
  bottomMargin = true,
  className = "",
  children,
}) {
  return (
    <div className={`flex flex-col ${bottomMargin ? "mb-4" : ""} ${className}`}>
      {title && (
        <Text
          text={title}
          className="my-auto mb-2 text-14-22-em text-neutral-600"
        />
      )}
      {children}
    </div>
  );
};

export default Section;
